import { type DatabaseExternalFile } from '@/lib/types';
import RemoveExternalFile from './RemoveExternalFile';
import ExternalFileFilenameAndLink from './ExternalFileFilenameAndLink';
import FileIcon from '../utils/FileIcon';
import ExternalFileChip from './ExternalFileChip';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';

type ExternalFileProps = {
  externalFile: DatabaseExternalFile;
};

const ExternalFile = ({ externalFile }: ExternalFileProps) => (
  <ExternalFileChip>
    <FileIcon
      filename={externalFile.externalFile.filename}
      mimeType={externalFile.externalFile.mimeType}
    />
    <ExternalFileFilenameAndLink
      href={externalFile.externalFile.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {externalFile.externalFile.filename}
    </ExternalFileFilenameAndLink>
    <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
      <RemoveExternalFile externalFile={externalFile} />
    </RestrictedToPortfolioMode>
  </ExternalFileChip>
);

export default ExternalFile;
